import { Heading2 } from '@blueprint/ui';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { CTALink } from 'listing-details/components/CTA/CTA';

export const AdditionalLinksWrapper = styled('div')(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;

        ${Heading2} {
            width: 100%;
            margin-bottom: ${theme.spacing['24px']};
        }

        ${CTALink} {
            border: none;
            border-top: 1px solid ${theme.colors['grey-stone']};
            &:last-of-type {
                border-bottom: 1px solid ${theme.colors['grey-stone']};
            }
        }

        ${theme.mq.medium} {
            flex-direction: row;
            flex-wrap: wrap;
            margin-left: -${theme.spacing['16px']};

            ${CTALink} {
                width: calc(50% - (${theme.spacing['16px']}));
                border: 1px solid ${theme.colors['grey-stone']};
                margin-left: ${theme.spacing['16px']};
                margin-bottom: ${theme.spacing['8px']};
            }

            ${Heading2} {
                margin: 0 0 ${theme.spacing['24px']} ${theme.spacing['16px']};
            }
        }

        ${theme.mq.large} {
            margin-left: -${theme.spacing['24px']};

            ${CTALink} {
                width: calc(50% - (${theme.spacing['24px']}));
                margin-left: ${theme.spacing['24px']};
            }

            ${Heading2} {
                margin-left: ${theme.spacing['24px']};
            }
        }
    `
);
